// extracted by mini-css-extract-plugin
export default {"button":"AccountingBookCreationPage_button__JKbzw","navBtn":"AccountingBookCreationPage_navBtn__8jm7+"};